// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.right-page-title {
  display: flex;
  justify-content: space-between;
}
.right-page-title h4 {
  font-weight: 700;
  margin-bottom: 0px;
}

.select-label {
  margin-top: 32px;
  gap: 8px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.select-label .select-title {
  margin-bottom: 0px;
}
.select-label .grade-select {
  border-radius: 5px;
  border: 1px solid #808080;
  color: #444343;
  padding: 5px;
}

.hide-add-additional-btn {
  background-color: transparent;
  color: #0A4064;
  border: none;
  padding: 5px;
  border-radius: 3px;
  font-size: 0.85rem;
  text-decoration: underline;
  font-style: italic;
  margin-bottom: 8px;
}
.hide-add-additional-btn:hover {
  color: #1786DB;
}

.add-additional-epr {
  background-color: white;
  border: 1px solid #0669B3;
  border-radius: 5px;
  margin-bottom: 24px;
  padding: 16px;
  width: fit-content;
}
.add-additional-epr .add-epr-note {
  background-color: #FEBF31;
  border-radius: 5px;
  color: black;
  font-size: 14px;
  margin-bottom: 16px;
  padding: 4px 8px;
}
.add-additional-epr .add-additional-epr-form {
  align-items: center;
  display: flex;
  gap: 8px;
  padding: 4px;
  width: 100%;
}
.add-additional-epr .inline-select-label {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 0px;
}
.add-additional-epr .inline-select-label .grade-select {
  border-radius: 5px;
  border: 1px solid #808080;
  color: #444343;
  padding: 3px;
}

.button-wrap-minus-margin {
  margin-left: -10px;
}

.saved-status-bar {
  background-color: #00AEEF;
  bottom: 0;
  color: black;
  font-size: 18px;
  font-weight: 600;
  left: 0;
  padding: 0.5rem 0;
  position: fixed;
  text-align: center;
  width: 100%;
  z-index: 9999;
}

.shared-group-section-title {
  background: linear-gradient(to right, #c0def0 70%, #ffffff 100%);
  border-radius: 3px;
  color: #0A4064;
  font-size: 22px;
  font-weight: 600;
  margin: 2rem 0rem 1rem 0rem;
  padding: 8px 16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/EprSummary.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AANA;EACI,aAAA;EACA,8BAAA;AASJ;AAPI;EACI,gBAAA;EACA,kBAAA;AASR;;AALA;EACI,gBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAQJ;AANI;EACI,kBAAA;AAQR;AALI;ECtBA,kBDuB0B;EACtB,yBAAA;EACA,cDIC;ECHD,YAAA;AAOR;;AAHA;EACI,6BAAA;EACA,cD1BM;EC2BN,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;AAMJ;AAJI;EACI,cDXW;ACiBnB;;AADA;EACI,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAIJ;AAFI;EACI,yBDpCI;ECqCJ,kBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAIR;AADI;EACI,mBAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AAGR;AAAI;EACI,mBAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;AAER;AAAQ;EC9EJ,kBD+E8B;EACtB,yBAAA;EACA,cDpDH;ECqDG,YAAA;AAEZ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,yBDnFU;ECoFV,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,OAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AAAJ;;AAGA;EACI,gEAAA;EACA,kBAAA;EACA,cDtGM;ECuGN,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;AAAJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n\n.right-page-title {\n    display: flex;\n    justify-content: space-between;\n\n    h4 {\n        font-weight: 700;\n        margin-bottom: 0px;\n    }\n}\n\n.select-label {\n    margin-top: 32px;\n    gap: 8px;\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n\n    .select-title {\n        margin-bottom: 0px;\n    }\n\n    .grade-select {\n        @include borderRadius(5px);\n        border: 1px solid $grey3;\n        color: $grey4a;\n        padding: 5px;\n    }\n}\n\n.hide-add-additional-btn {\n    background-color: transparent;\n    color: $dk-blue;\n    border: none;\n    padding: 5px;\n    border-radius: 3px;\n    font-size: 0.85rem;\n    text-decoration: underline;\n    font-style: italic;\n    margin-bottom: 8px;\n\n    &:hover {\n        color: $pearl-blue-hover;\n    }\n}\n\n\n.add-additional-epr {\n    background-color: white;\n    border: 1px solid $pearl-blue;\n    border-radius: 5px;\n    margin-bottom: 24px;\n    padding: 16px;\n    width: fit-content;\n\n    .add-epr-note {\n        background-color: $important;\n        border-radius: 5px;\n        color: black;\n        font-size: 14px;\n        margin-bottom: 16px;\n        padding: 4px 8px;\n    }\n\n    .add-additional-epr-form {\n        align-items: center;\n        display: flex;\n        gap: 8px;\n        padding: 4px;\n        width: 100%;\n    }\n\n    .inline-select-label {\n        align-items: center;\n        display: flex;\n        gap: 8px;\n        margin-bottom: 0px;\n\n        .grade-select {\n            @include borderRadius(5px);\n            border: 1px solid $grey3;\n            color: $grey4a;\n            padding: 3px;\n        }\n    }\n}\n\n.button-wrap-minus-margin {\n    margin-left: -10px;\n}\n\n.saved-status-bar {\n    background-color: $information;\n    bottom: 0;\n    color: black;\n    font-size: 18px;\n    font-weight: 600;\n    left: 0;\n    padding: 0.5rem 0;\n    position: fixed;\n    text-align: center;\n    width: 100%;\n    z-index: 9999;\n}\n\n.shared-group-section-title {\n    background: linear-gradient(to right, #c0def0 70%, #ffffff 100%);\n    border-radius: 3px;\n    color: $dk-blue;\n    font-size: 22px;\n    font-weight: 600;\n    margin: 2rem 0rem 1rem 0rem;\n    padding: 8px 16px;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
